// test1291
(1291 && 0);
